import './style';
import './style/myModal.css';
import { render } from 'preact';
import App from './components/app';
import NewApp from './components/NewApp';
import { getChannelSource, getAppParams } from './components/app.util';
import intl from 'react-intl-universal';

const locales = {
  en: require('./locales/en-us.json'),
  'zh-cn': require('./locales/zh-cn.json'),
};

const { locale } = getAppParams();
const { isIntegration } = getChannelSource();

intl
  .init({
    currentLocale: Object.keys(locales).includes(locale) ? locale : 'zh-cn',
    locales,
  })
  .then(() => {
    // NewApp：新架构下的loading页面，目前仅作为error页面，后续逐步迁移
    render(isIntegration ? <NewApp /> : <App />, document.body);
  });
